import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import ProductsPage from './pages/ProductsPage';
import InspirationPage from './pages/InspirationPage';
import QuotePage from './pages/QuotePage';
import ProfessioneelPage from './pages/ProfessioneelPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import CustomerDashboard from './pages/CustomerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ResellerDashboard from './pages/ResellerDashboard';
import RestpartijenPage from './pages/RestpartijenPage';
import ResellerAanvraagPage from './pages/ResellerAanvraagPage';
import ProductDetailPage from './pages/ProductDetailPage';
import RetourPage from './pages/RetourPage';
import ContactPage from './pages/ContactPage';
import DynamicSchema from './components/DynamicSchema';
import TestAccountSwitcher from './components/TestAccountSwitcher';
import TermsPage from './pages/TermsPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import { AuthProvider } from './store/AuthContext';
import { LanguageProvider } from './store/LanguageContext';

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          {/* overflow-x-clip: één te breed element mag nooit meer de hele
              gsm-viewport uitrekken (oorzaak van de zijwaartse scroll die
              Franky zag) — inhoud krimpt/truncate dan gewoon binnen 100vw. */}
          <div className="min-h-screen flex flex-col overflow-x-clip">
            {/* TestAccountSwitcher renders the "return to admin" banner only
                when impersonating. The active switch UI lives in the Navbar. */}
            <TestAccountSwitcher />
            <Navbar />
            <main className="flex-1 flex flex-col [&>*]:w-full [&>*]:max-w-full [&>*]:min-w-0">
            {/* [&>*]-regels: een pagina (flex-item) mag nooit breder worden
                 dan het scherm — dit was de bron van de gsm-zijscroll. */}
              <Routes>
                <Route path="/" element={<ProductsPage />} />
                <Route path="/producten" element={<Navigate to="/" replace />} />
                <Route path="/calculator" element={<Navigate to="/#calculator" replace />} />
                <Route path="/offerte" element={<QuotePage />} />
                <Route path="/inspiratie" element={<InspirationPage />} />
                <Route path="/professioneel" element={<ProfessioneelPage />} />
                <Route path="/architecten" element={<Navigate to="/professioneel" replace />} />
                <Route path="/custom" element={<Navigate to="/professioneel" replace />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/dashboard" element={<CustomerDashboard />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/reseller-dashboard" element={<ResellerDashboard />} />
                {/* V6 punt 27: Restpartijen op pauze — pagina onzichtbaar, later heractiveerbaar */}
                <Route path="/restpartijen" element={<Navigate to="/" replace />} />
                <Route path="/reseller-aanvraag" element={<ResellerAanvraagPage />} />
                <Route path="/steen/:slug" element={<ProductDetailPage />} />
                <Route path="/retourbeleid" element={<RetourPage />} />
                <Route path="/overschotten" element={<Navigate to="/restpartijen" replace />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/dashboard-legacy" element={<DashboardPage />} />
                <Route path="/voorwaarden" element={<TermsPage />} />
                <Route path="/cookiebeleid" element={<CookiePolicyPage />} />
              </Routes>
            </main>
            <Footer />
            <CookieBanner />
            <DynamicSchema />
          </div>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}
